<template>
  <div class="page-content receipts">
    <div class="row">
      <div class="col-sm-6 col-12">
        <pull-up-receipt />
        <send-receipt />
      </div>
      <div class="col-sm-6 col-12">
        <send-ride-history />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, defineAsyncComponent, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const PullUpReceipt = defineAsyncComponent(() => import('./Receipts/PullUpReceipt.vue') as any);

const SendReceipt = defineAsyncComponent(() => import('./Receipts/SendReceipt.vue') as any);

const SendRideHistory = defineAsyncComponent(() => import('./Receipts/SendRideHistory.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
